// AUTO-GENERATED from packages/core-schemas/src/dreamwright_core_schemas/api_contracts.py
// Do not edit manually. Run: uv run python scripts/gen_rules_types.py

export const RULES_MAX_BODY_BYTES: number = 8192;
export const RULES_MAX_STRUCTURED_LIST_LENGTH: number = 32;
export const RULES_MAX_STRUCTURED_LIST_ITEM_BYTES: number = 200;
export const RULES_MAX_TOTAL_DOCUMENT_BYTES: number = 32768;

export const CONTENT_LANGUAGE_CODES: string[] = ['en', 'ja', 'zh', 'de', 'hi', 'fr', 'ko', 'pt', 'it', 'es', 'id', 'nl', 'tr', 'fil', 'pl', 'sv', 'bg', 'ro', 'ar', 'cs', 'el', 'fi', 'hr', 'ms', 'sk', 'da', 'ta', 'uk', 'ru', 'vi'];

export interface RulesStructured {
  tone: string[];
  content_language_hint: string | null;
  aspect_ratio_default: string | null;
  banned_terms: string[];
  always_include: string[];
}

export interface RulesDocumentV1 {
  version: 1;
  body: string;
  structured: RulesStructured;
}

export const EMPTY_RULES_DOCUMENT: RulesDocumentV1 = {
  version: 1,
  body: '',
  structured: {
    tone: [],
    content_language_hint: null,
    aspect_ratio_default: null,
    banned_terms: [],
    always_include: [],
  },
};

export type RulesUpdateActor = 'user' | 'director' | 'director_proposal' | 'clone' | 'template';
export const RULES_UPDATE_ACTOR_VALUES: readonly RulesUpdateActor[] = ['user', 'director', 'director_proposal', 'clone', 'template'];

export interface ReplaceBodyRulesRequest {
  op: 'replace_body';
  document: RulesDocumentV1;
  expected_version: number;
}

export interface RevertRulesRequest {
  op: 'revert';
  revert_to_version: number;
  expected_version: number;
}

export type RulesPutBody = ReplaceBodyRulesRequest | RevertRulesRequest;

export type RulesConflictReason = 'version_mismatch' | 'revert_target_missing';
export interface RulesConflictDetail {
  error: 'rules_version_mismatch';
  reason: RulesConflictReason;
  scope: 'user' | 'project';
  expected: number;
  actual: number;
  expected_version: number;
  current_version: number;
  current_document: RulesDocumentV1;
  revert_to_version: number | null;
}

export interface RulesConflictResponse {
  detail: RulesConflictDetail;
}

export interface RulesHistoryEntry {
  version: number;
  updated_by: RulesUpdateActor;
  updated_at: string;
  document: RulesDocumentV1;
}

export interface RulesResponse {
  scope: 'user' | 'project' | 'merged';
  user: RulesDocumentV1 | null;
  user_current_version: number;
  project: RulesDocumentV1 | null;
  project_current_version: number;
  merged: RulesDocumentV1 | null;
  history: RulesHistoryEntry[] | null;
}

export function utf8ByteLength(s: string): number { return new TextEncoder().encode(s).length; }

export function validateRulesDocument(doc: RulesDocumentV1): string | null {
  if (doc.version !== 1) return 'rules_unsupported_version';
  if (utf8ByteLength(doc.body) > RULES_MAX_BODY_BYTES) return 'rules_body_too_long';
  const lists: [string, string[]][] = [
    ['structured.tone', doc.structured.tone],
    ['structured.banned_terms', doc.structured.banned_terms],
    ['structured.always_include', doc.structured.always_include],
  ];
  for (const [field, items] of lists) {
    if (items.length > RULES_MAX_STRUCTURED_LIST_LENGTH) return `rules_list_too_long:${field}`;
    for (const item of items) {
      if (utf8ByteLength(item) > RULES_MAX_STRUCTURED_LIST_ITEM_BYTES) return `rules_list_item_too_long:${field}`;
      if (!item.trim()) return `rules_field_empty:${field}`;
    }
  }
  const total = utf8ByteLength(JSON.stringify(doc));
  if (total > RULES_MAX_TOTAL_DOCUMENT_BYTES) return 'rules_document_over_cap';
  return null;
}

export type ApiValue =
  | string
  | number
  | boolean
  | null
  | ApiValue[]
  | { readonly [key: string]: ApiValue };

export type ApiRecord = { readonly [key: string]: ApiValue };

export class RulesResponseParseError extends Error {
  readonly field: string;
  readonly expected: string;
  constructor(field: string, expected: string, gotType: string) {
    super(`rules_response_parse_error: field=${field} expected=${expected} got=${gotType}`);
    this.name = 'RulesResponseParseError';
    this.field = field;
    this.expected = expected;
  }
}

function _typeOf(value: ApiValue | null | undefined): string {
  if (value === null) return 'null';
  if (value === undefined) return 'undefined';
  if (Array.isArray(value)) return 'array';
  return typeof value;
}

export function isApiRecord(value: ApiValue | null | undefined): value is ApiRecord {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isApiValueArray(value: ApiValue | null | undefined): value is ApiValue[] {
  return Array.isArray(value);
}

function _record(raw: ApiValue | null | undefined, field: string): ApiRecord {
  if (!isApiRecord(raw)) {
    throw new RulesResponseParseError(field, 'object', _typeOf(raw));
  }
  return raw;
}

function _string(raw: ApiValue | undefined, field: string): string {
  if (typeof raw !== 'string') {
    throw new RulesResponseParseError(field, 'string', _typeOf(raw));
  }
  return raw;
}

function _stringOrNull(raw: ApiValue | undefined, field: string): string | null {
  if (raw === null || raw === undefined) return null;
  if (typeof raw !== 'string') {
    throw new RulesResponseParseError(field, 'string|null', _typeOf(raw));
  }
  return raw;
}

function _number(raw: ApiValue | undefined, field: string): number {
  if (typeof raw !== 'number' || !Number.isFinite(raw)) {
    throw new RulesResponseParseError(field, 'number', _typeOf(raw));
  }
  return raw;
}

function _integer(raw: ApiValue | undefined, field: string): number {
  const value = _number(raw, field);
  if (!Number.isInteger(value)) {
    throw new RulesResponseParseError(field, 'integer', 'number');
  }
  return value;
}

function _integerOrNull(raw: ApiValue | undefined, field: string): number | null {
  if (raw === null) return null;
  return _integer(raw, field);
}

function _stringArray(raw: ApiValue | undefined, field: string): string[] {
  if (!isApiValueArray(raw)) {
    throw new RulesResponseParseError(field, 'string[]', _typeOf(raw));
  }
  const out: string[] = [];
  for (let i = 0; i < raw.length; i++) {
    const item = raw[i];
    if (typeof item !== 'string') {
      throw new RulesResponseParseError(`${field}[${i}]`, 'string', _typeOf(item));
    }
    out.push(item);
  }
  return out;
}

function _fieldValue(record: ApiRecord, key: string): ApiValue | undefined {
  return Object.prototype.hasOwnProperty.call(record, key) ? record[key] : undefined;
}

export function parseRulesStructured(raw: ApiValue | null | undefined): RulesStructured {
  const obj = _record(raw, 'structured');
  return {
    tone: _stringArray(_fieldValue(obj, 'tone'), 'structured.tone'),
    content_language_hint: _stringOrNull(_fieldValue(obj, 'content_language_hint'), 'structured.content_language_hint'),
    aspect_ratio_default: _stringOrNull(_fieldValue(obj, 'aspect_ratio_default'), 'structured.aspect_ratio_default'),
    banned_terms: _stringArray(_fieldValue(obj, 'banned_terms'), 'structured.banned_terms'),
    always_include: _stringArray(_fieldValue(obj, 'always_include'), 'structured.always_include'),
  };
}

export function parseRulesDocumentV1(raw: ApiValue | null | undefined): RulesDocumentV1 {
  const obj = _record(raw, 'document');
  const version = _fieldValue(obj, 'version');
  if (version !== 1) {
    throw new RulesResponseParseError('document.version', '1', _typeOf(version));
  }
  return {
    version: 1,
    body: _string(_fieldValue(obj, 'body'), 'document.body'),
    structured: parseRulesStructured(_fieldValue(obj, 'structured')),
  };
}

function _rulesConflictReason(raw: ApiValue | undefined, field: string): RulesConflictReason {
  const value = _string(raw, field);
  if (value === 'version_mismatch' || value === 'revert_target_missing') return value;
  throw new RulesResponseParseError(field, 'RulesConflictReason', 'string');
}

function _rulesConflictScope(raw: ApiValue | undefined, field: string): 'user' | 'project' {
  const value = _string(raw, field);
  if (value === 'user' || value === 'project') return value;
  throw new RulesResponseParseError(field, "'user' | 'project'", 'string');
}

export function parseRulesConflictDetail(raw: ApiValue | null | undefined): RulesConflictDetail {
  const obj = _record(raw, 'conflict.detail');
  const error = _fieldValue(obj, 'error');
  if (error !== 'rules_version_mismatch') {
    throw new RulesResponseParseError('conflict.detail.error', "'rules_version_mismatch'", _typeOf(error));
  }
  return {
    error: 'rules_version_mismatch',
    reason: _rulesConflictReason(_fieldValue(obj, 'reason'), 'conflict.detail.reason'),
    scope: _rulesConflictScope(_fieldValue(obj, 'scope'), 'conflict.detail.scope'),
    expected: _integer(_fieldValue(obj, 'expected'), 'conflict.detail.expected'),
    actual: _integer(_fieldValue(obj, 'actual'), 'conflict.detail.actual'),
    expected_version: _integer(_fieldValue(obj, 'expected_version'), 'conflict.detail.expected_version'),
    current_version: _integer(_fieldValue(obj, 'current_version'), 'conflict.detail.current_version'),
    current_document: parseRulesDocumentV1(_fieldValue(obj, 'current_document')),
    revert_to_version: _integerOrNull(_fieldValue(obj, 'revert_to_version'), 'conflict.detail.revert_to_version'),
  };
}

export function parseRulesConflictResponse(raw: ApiValue | null | undefined): RulesConflictResponse | null {
  if (!isApiRecord(raw)) return null;
  const detail = _fieldValue(raw, 'detail');
  if (!isApiRecord(detail)) return null;
  if (_fieldValue(detail, 'current_document') === undefined) return null;
  return { detail: parseRulesConflictDetail(detail) };
}

export function parseRulesUpdateActor(raw: ApiValue | undefined, field: string): RulesUpdateActor {
  const value = _string(raw, field);
  for (const allowed of RULES_UPDATE_ACTOR_VALUES) {
    if (value === allowed) return allowed;
  }
  throw new RulesResponseParseError(field, 'RulesUpdateActor', 'string');
}

export function parseRulesHistoryEntry(raw: ApiValue | null | undefined): RulesHistoryEntry {
  const obj = _record(raw, 'history_entry');
  return {
    version: _number(_fieldValue(obj, 'version'), 'history_entry.version'),
    updated_by: parseRulesUpdateActor(_fieldValue(obj, 'updated_by'), 'history_entry.updated_by'),
    updated_at: _string(_fieldValue(obj, 'updated_at'), 'history_entry.updated_at'),
    document: parseRulesDocumentV1(_fieldValue(obj, 'document')),
  };
}

function _rulesDocOrNull(raw: ApiValue | undefined, _field: string): RulesDocumentV1 | null {
  if (raw === null || raw === undefined) return null;
  return parseRulesDocumentV1(raw);
}

function _historyOrNull(raw: ApiValue | undefined, field: string): RulesHistoryEntry[] | null {
  if (raw === null || raw === undefined) return null;
  if (!isApiValueArray(raw)) {
    throw new RulesResponseParseError(field, 'array|null', _typeOf(raw));
  }
  const out: RulesHistoryEntry[] = [];
  for (let i = 0; i < raw.length; i++) {
    out.push(parseRulesHistoryEntry(raw[i]));
  }
  return out;
}

function _responseScope(raw: ApiValue | undefined, field: string): 'user' | 'project' | 'merged' {
  const value = _string(raw, field);
  if (value === 'user' || value === 'project' || value === 'merged') return value;
  throw new RulesResponseParseError(field, "'user'|'project'|'merged'", 'string');
}

export function parseRulesResponse(raw: ApiValue | null | undefined): RulesResponse {
  const obj = _record(raw, 'response');
  return {
    scope: _responseScope(_fieldValue(obj, 'scope'), 'response.scope'),
    user: _rulesDocOrNull(_fieldValue(obj, 'user'), 'response.user'),
    user_current_version: _number(_fieldValue(obj, 'user_current_version'), 'response.user_current_version'),
    project: _rulesDocOrNull(_fieldValue(obj, 'project'), 'response.project'),
    project_current_version: _number(_fieldValue(obj, 'project_current_version'), 'response.project_current_version'),
    merged: _rulesDocOrNull(_fieldValue(obj, 'merged'), 'response.merged'),
    history: _historyOrNull(_fieldValue(obj, 'history'), 'response.history'),
  };
}

export const RULES_JSON_SCHEMA = {"$defs": {"RulesStructured": {"additionalProperties": false, "description": "Typed structured sidecar for `RulesDocumentV1`.\n\nAll fields are optional; the store never invents values. Unknown keys are\nrejected via ``Extra.forbid`` so a client cannot silently smuggle new\nschema keys through the write boundary. Semantic caps (list length,\nper-item byte size) are enforced in the repository via\n``dreamwright_core_schemas.rules_validation.validate_rules_document``.", "properties": {"always_include": {"items": {"type": "string"}, "title": "Always Include", "type": "array"}, "aspect_ratio_default": {"anyOf": [{"type": "string"}, {"type": "null"}], "default": null, "title": "Aspect Ratio Default"}, "banned_terms": {"items": {"type": "string"}, "title": "Banned Terms", "type": "array"}, "content_language_hint": {"anyOf": [{"type": "string"}, {"type": "null"}], "default": null, "title": "Content Language Hint"}, "tone": {"items": {"type": "string"}, "title": "Tone", "type": "array"}}, "title": "RulesStructured", "type": "object"}}, "additionalProperties": false, "description": "The single wire/storage shape for user and project rules.\n\nUsed verbatim as: (a) REST request/response body, (b) Director tool\n`update_rules` document payload, (c) `data` JSONB column contents on\nboth `user_rules` and `project_rules`, and (d) the base type\n`scripts/gen_rules_types.py` codegens into\n`apps/console/src/generated/rulesDocument.ts`.", "properties": {"body": {"default": "", "title": "Body", "type": "string"}, "structured": {"$ref": "#/$defs/RulesStructured"}, "version": {"const": 1, "default": 1, "title": "Version", "type": "integer"}}, "title": "RulesDocumentV1", "type": "object"};
export const RULES_CONFLICT_JSON_SCHEMA = {"$defs": {"RulesDocumentV1": {"additionalProperties": false, "description": "The single wire/storage shape for user and project rules.\n\nUsed verbatim as: (a) REST request/response body, (b) Director tool\n`update_rules` document payload, (c) `data` JSONB column contents on\nboth `user_rules` and `project_rules`, and (d) the base type\n`scripts/gen_rules_types.py` codegens into\n`apps/console/src/generated/rulesDocument.ts`.", "properties": {"body": {"default": "", "title": "Body", "type": "string"}, "structured": {"$ref": "#/$defs/RulesStructured"}, "version": {"const": 1, "default": 1, "title": "Version", "type": "integer"}}, "title": "RulesDocumentV1", "type": "object"}, "RulesStructured": {"additionalProperties": false, "description": "Typed structured sidecar for `RulesDocumentV1`.\n\nAll fields are optional; the store never invents values. Unknown keys are\nrejected via ``Extra.forbid`` so a client cannot silently smuggle new\nschema keys through the write boundary. Semantic caps (list length,\nper-item byte size) are enforced in the repository via\n``dreamwright_core_schemas.rules_validation.validate_rules_document``.", "properties": {"always_include": {"items": {"type": "string"}, "title": "Always Include", "type": "array"}, "aspect_ratio_default": {"anyOf": [{"type": "string"}, {"type": "null"}], "default": null, "title": "Aspect Ratio Default"}, "banned_terms": {"items": {"type": "string"}, "title": "Banned Terms", "type": "array"}, "content_language_hint": {"anyOf": [{"type": "string"}, {"type": "null"}], "default": null, "title": "Content Language Hint"}, "tone": {"items": {"type": "string"}, "title": "Tone", "type": "array"}}, "title": "RulesStructured", "type": "object"}}, "additionalProperties": false, "description": "Atomic current-state snapshot returned for a rules write conflict.\n\nThe repository captures ``current_document`` and ``current_version`` while\nholding the same advisory lock that rejects the stale write.  Keeping the\nsnapshot on the typed error prevents a follow-up GET from racing a second\nwriter before the caller chooses how to recover.\n\n``expected``/``actual`` retain the original RFC-0944 wire fields for older\nclients.  New clients use the unambiguous ``expected_version`` and\n``current_version`` names plus ``reason``.", "properties": {"actual": {"title": "Actual", "type": "integer"}, "current_document": {"$ref": "#/$defs/RulesDocumentV1"}, "current_version": {"title": "Current Version", "type": "integer"}, "error": {"const": "rules_version_mismatch", "default": "rules_version_mismatch", "title": "Error", "type": "string"}, "expected": {"title": "Expected", "type": "integer"}, "expected_version": {"title": "Expected Version", "type": "integer"}, "reason": {"enum": ["version_mismatch", "revert_target_missing"], "title": "Reason", "type": "string"}, "revert_to_version": {"anyOf": [{"type": "integer"}, {"type": "null"}], "default": null, "title": "Revert To Version"}, "scope": {"enum": ["user", "project"], "title": "Scope", "type": "string"}}, "required": ["reason", "scope", "expected", "actual", "expected_version", "current_version", "current_document"], "title": "RulesConflictDetail", "type": "object"};
